import React from "react";

import { IProduct } from "../../../models/catalogue.interfaces";
import { listOptions } from "./utils";

export const BasketLineColorOption = (props: {
    product: IProduct;
}): React.ReactNode => {
    const colorOption = listOptions(props.product).find((option) => {
        return option.key === "option_color";
    });
    const productColor = colorOption ? (
        <li key={colorOption.key}>
            <span>{colorOption.name}</span>:{" "}
            <strong>{colorOption.value}</strong>
        </li>
    ) : null;
    return productColor;
};
